// extracted by mini-css-extract-plugin
export default {"layout":"styles__layout--fdedeb6e24e36cf5a96a","content":"styles__content--cd04c995f0d6eba4910b","sideBarVisible":"styles__sideBarVisible--baff5957eeeeee639687"};